// `${objeto}` vira "[object Object]" — era o que o evento de renovação de JWT guardava.
export default function stringifyError(error: unknown): string {
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  if (typeof error === 'string') return error;

  try {
    return JSON.stringify(error) ?? String(error);
  } catch (e) {
    return String(error);
  }
}
